import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface StoriesWrittenHistoryResponse {
  stories_written_history: {
    student_id: number
    stories_written: number
  }[]
}

export type StoriesWrittenHistoryData = StoriesWrittenHistoryResponse['stories_written_history']

export async function storiesWrittenHistory(
  this: StudentEventsService,
  product: LegacyProductRe,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<StoriesWrittenHistoryData>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('stories_written_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<StoriesWrittenHistoryResponse>(url, query)
  if (!data) return null

  const { stories_written_history } = data
  if (stories_written_history.length === 0) return null

  return stories_written_history
}
